// 将s所有属性复制给R，isOverWrit是否同名覆盖

function mergeProps(r, s, isOverWrite) { // TODO:
  if (!s || !r) return r
  for (var p in s) {
    if (isOverWrite !== false || !(p in r)) {
      r[p] = s[p]
    }
  }
  return r
}

function getFormatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds()
    // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '')
      .substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) :
        (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
// 将字符串转换成date
function convertDateFromString(dateString) {
  if (dateString) {
    var arr1 = dateString.split(' ')
    var sdate = arr1[0].split('-')
    var time = arr1[1].split(':')
    var date = new Date(sdate[0], sdate[1] - 1, sdate[2], time[0], time[1], time[2])
    return date
  }
}

// 过滤表单的undefined属性
function filterUndefined(obj) {
  for (let key in obj) {
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key]
    }
  }
  return obj
}

// 保留两位小数点
function returnFloat(value) {
  value = Math.round(parseFloat(value) * 100) / 100
  var xsd = value.toString().split('.')
  if (xsd.length === 1) {
    value = value.toString() + '.00'
    return value
  }
  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      value = value.toString() + '0'
    }
    return value
  }
}


function formatDuration(duration) {
  if (duration === undefined || duration === null) {
    return ''
  }
  let h = parseInt(duration / 3600)
  let m = parseInt(duration / 60)
  let s = duration % 60
  let str = '';
  str += h > 0 ? (h + '小時') : ''
  str += m > 0 ? (m + '分') : ''
  str += s > 0 ? (s + '秒') : ''
  return str;
}

function formatDurationSimple(duration) {

  if (duration === undefined || duration === null) {
    return ''
  }
  let h = parseInt(duration / 3600)
  let m = parseInt(duration / 60)
  let s = duration % 60
  let str = '';
  str += h > 0 ? (h + ':') : ''
  str += m >= 0 ? ((m < 10 ? "0" + m : (m)) + ':') : '00'
  str += s > 0 ? (s < 10 ? "0" + s : (s)) : '00'

  return str;
}


function deepCopy(obj, deep) {
  debugger;
  if (typeof obj == "function") {
    return new Function("return " + obj.toString())();
  } else if (obj === null || typeof obj !== "object") {
    return obj;
  } else {
    var name,
      target = Array.isArray(obj) ? [] : {},
      value;

    for (name in obj) {
      value = obj[name];

      if (value === obj) {
        continue;
      }
      if (deep) {
        if (Array.isArray(value) || typeof value == "object") {
          target[name] = this.copy(value, deep);
        } else if (typeof value == "function") {
          target[name] = new Function("return " + value.toString())();
        } else {
          target[name] = value;
        }
      } else {
        target[name] = value;
      }
    }
    return target;
  }
}


export default {
  mergeProps: mergeProps,
  getFormatDate: getFormatDate,
  convertDateFromString: convertDateFromString,
  filterUndefined: filterUndefined,
  returnFloat: returnFloat,
  formatDuration: formatDuration,
  formatDurationSimple: formatDurationSimple,
  deepCopy: deepCopy
}